module.exports = __webpack_public_path__ + "img/setup-3.8cf43313.png";